import React, { useContext } from 'react';

import { Box, styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import Button from 'components/Button';
import ArrowRight from 'components/SvgComponents/icons/ArrowRight';
import { OrganizationContext } from 'containers/GlobalWrapper/BusinessOrganizationDataValidation';
import { Routing } from 'routing/routing';
import globalMessages from 'translations/messages/global-messages';
import { authorizations } from 'utils/constants';

const Box_BannerWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'fullWidth',
})(({ theme, fullWidth }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: 16,
  gap: theme.spacing(2),
  boxShadow: 'none',
  padding: theme.spacing(4, 6),
  justifyContent: 'space-between',
  backgroundColor: theme.palette.error.light,
  width: fullWidth ? '100%' : 800,
}));

const Typography_Subtitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

const Button_Upgrade = styled(Button)(() => ({
  '& .MuiButton-root': {
    marginInlineStart: 'auto',
  },
}));

export function OverSeatOfferBanner({ intl, currentPlan, fullWidth, blockItemsCreation }) {
  const businessOrganization = useContext(OrganizationContext);
  const history = useHistory();

  const countSeat = businessOrganization?.used_licenses_count || 0;
  const countTotalSeat = currentPlan?.total_user_plan || 0;
  const overSeat = countSeat - countTotalSeat > 0 ? countSeat - countTotalSeat : 0;
  const canWriteOffer =
    businessOrganization?.authorizations?.indexOf(authorizations.organization.writeOffer) > -1;

  const onUpgradeOfferClick = () => {
    history.push(Routing.organizations.contract(businessOrganization?.id));
  };

  const getDescription = () => {
    if (blockItemsCreation) {
      return canWriteOffer
        ? intl.formatMessage(globalMessages.items_limit_reached_description_admin)
        : intl.formatMessage(globalMessages.items_limit_reached_description_user);
    }
    return (
      <>
        {intl.formatMessage(
          canWriteOffer
            ? globalMessages.reach_organization_seat_limit_description_admin
            : globalMessages.reach_organization_seat_limit_description_user,
          {
            overSeat,
            countSeat,
            countTotalSeat,
          },
        )}
      </>
    );
  };

  return (
    <Box_BannerWrapper fullWidth={fullWidth}>
      <div>
        <Typography component="p" variant="subtitleError">
          {intl.formatMessage(globalMessages.reach_organization_seat_limit_title)}
        </Typography>
        <Typography_Subtitle component="p" variant="subtitleLightBold">
          {getDescription()}
        </Typography_Subtitle>
      </div>
      {canWriteOffer && (
        <Button_Upgrade onClick={onUpgradeOfferClick} startIcon={<ArrowRight />} variant="danger">
          {intl.formatMessage(globalMessages.upgrade_offer_button_title)}
        </Button_Upgrade>
      )}
    </Box_BannerWrapper>
  );
}

OverSeatOfferBanner.propTypes = {
  intl: PropTypes.object.isRequired,
  currentPlan: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool,
  blockItemsCreation: PropTypes.bool,
};

export default injectIntl(OverSeatOfferBanner);
